<template>
    <CContainer>
        <CRow>
            <h6>
                Descripción de la sección
            </h6>
        </CRow>
        <CCard class="mt-4">
          <CCardBody class="p-3">
            <CDataTable
                :items="items.filter((item)=> (item.Estado_Pedido == 'EM'))"
                :fields="fields"
                :tableFilter="{label: 'Buscar: ', placeholder:' '}"
                :items-per-page-select="{label:'Items por página', values: [10, 20, 50]}"
                :items-per-page="10"
                hover
                pagination>
                <template #Valor_Total="{item}">
                  <td align="right">{{formatter.format(item.Valor_Total, 0)}}</td>
                </template>
                <template #Numero="{item}">
                  <td align="right">{{item.Numero}}</td>
                </template>
                <!-- <template #Estado_Pedido="{item}">
                  <td v-if="item.Estado_Pedido == 'CA'">Cargado</td>
                  <td v-if="item.Estado_Pedido == 'EM'">Entregado</td>
                  <td v-if="item.Estado_Pedido == 'AU'">Autorizado</td>
                  <td v-if="item.Estado_Pedido == 'PE'">Pendiente</td>
                  <td v-if="item.Estado_Pedido == 'PA'">Parcial</td>
                  <td v-if="item.Estado_Pedido == 'TO'">Total</td>
                  <td v-if="item.Estado_Pedido == 'AL'">Alistamiento</td>
                </template> -->
                <template #Fecha_Emision="{item}">
                  <td align="right">{{item.Fecha_Emision}}</td>
                </template>
                <template #setApproval="{item}">
                  <td >
                    <CButton 
                      color="primary"
                      square
                      size="sm"
                      @click="preAknowledge(item)">
                      <CIcon name="cil-clipboard"/>
                    </CButton>
                  </td>
                </template>
            </CDataTable>
          </CCardBody>
        </CCard>
        <CModal
          title=""
          color="dark"
          :show.sync="confirmationModal"
          :centered="true"
          :closeOnBackdrop="false"
          :backdrop="true"
          >
          <template v-slot:header>
              <h4>Acuse recibo</h4>
          </template>
          <template v-slot:body-wrapper>
              <CContainer class="p-4">
                <div>
                  <CRow>
                    <CCol sm="12">
                      <div class="form-group" role="group">
                        <label class="text-muted font-weight-bold col-sm-12" for="">Fecha:</label>
                        <DatePicker
                          type="date"
                          v-model="fecha_Acuse"
                          format="DD/MM/YYYY"
                          value-type="YYYY-MM-DD"
                          placeholder="dd/mm/aaaa"
                          :editable="false" />
                        {{ fecha_Acuse }}
                      </div>
                      <div class="form-group" role="group">
                        <label class="text-muted font-weight-bold col-sm-12" for="">Hora: </label>
                        <DatePicker
                          type="time"
                          v-model="horaAcuse"
                          format="HH:mm a"
                          value-type="HH:mm:ss"
                          placeholder="hh:mm:ss"
                          :editable="false" />
                        {{ horaAcuse }}
                      </div>
                    </CCol>
                  </CRow>                 
                  <CRow>
                    <CCol sm="12">
                      <CSelect
                        class="mr-4"
                        :value.sync="acuse_Recibo"
                        :options="[{value: 'V', label: 'Acusar'}, {value: 'F', label: 'Rechazar'}]"
                        label="Acuse recibo: "
                        addLabelClasses="text-muted font-weight-bold col-sm-12 px-3 mx-1" 
                        addInputClasses="col-sm-12 ml-3"
                      />
                    </CCol>
                  </CRow>                 
                </div>
              </CContainer>
          </template>
          <template v-slot:footer>
            <CContainer  align="center">
                <CButton
                  color="success"
                  square 
                  class="mr-2 d-inline-block"
                  @click="acknowledge()"
                  :disabled="!fecha_Acuse">
                  <CIcon name="cil-plus"/>
                  <span class="align-middle">Aceptar</span>
                </CButton>
                <CButton
                  color="secondary"
                  square 
                  class="mr-2 d-inline-block"
                  @click="
                    confirmationModal=false
                    fecha_Acuse = moment().format()
                  ">
                  <CIcon name="cil-x"/>
                  <span class="align-middle">Cancelar</span>
                </CButton>
            </CContainer>
          </template>>
        </CModal>
        <CElementCover  v-show="loading"/>        
    </CContainer>
</template>

<script>
  import moment from "moment"
  import DatePicker from "vue2-datepicker"
  import { formatter } from '../../general'
  import constants from '../../constants'
  import {
    dataGridPedidos, 
    actualizaPedido
  } from '../../api'
  
  const fields = [
    { key: 'Fecha_Emision', label:'Fecha Emisión', _style:'text-align:center;' },
    { key: 'Numero', label:'Número', _style:'text-align:center;' },
    { key: 'Dependencia', _style:'text-align:center;' },
    { key: 'Valor_Total', label:'Valor Total', _style:'text-align:center;' },
    { key: 'setApproval', label:'', _style:'text-align:center;' },
  ]

  export default {
    name: 'AcknowledgeReceipt',
    data () {
      return {
        moment,
        formatter,
        loading: false,
        items: [],
        fields,
        details: [],
        confirmationModal: false,
        preAcknowledgedItem: {},
        fecha_Acuse: "",
        horaAcuse: "",
        acuse_Recibo: ''
      }
    },
    components:{ 
      DatePicker
    },
    methods:{
      async getData() {
        this.loading = true
          
        try {
          const { response } = await dataGridPedidos(this, this.$store.state.user.data.id_Directorio)
          this.items = response
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      preAknowledge(item){
        this.fecha_Acuse = moment().format()
        this.confirmationModal = true
        this.preAcknowledgedItem = {...item}
      },
      async acknowledge(){
        this.loading = true

        try {
          this.confirmationModal = false
          
          const body = {
            "Id_Pedido": this.preAcknowledgedItem.Id_Pedido,
            "Acuse_Recibo": this.acuse_Recibo,
            "Fecha_Acuse": moment(this.fecha_Acuse).format('YYYY-MM-DD HH:mm:ss'),
            "Id_Usuario": this.$store.state.user.data.id_Usuario
          }
          const response = await actualizaPedido(
            this,
            body
          )
          console.log(response)
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: constants.messages.notDoneEdit,
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    }, 
    mounted(){
      this.getData()
    }
  }
</script>